export const integrationIconNames = [
  'batchbud',
  'biotrack',
  'blaze',
  'canix',
  'cannveya',
  'cova',
  'distru',
  'dutchie',
  'dynamics365',
  'flourish',
  'flowhub',
  'growflow',
  'maxq',
  'meadow',
  'metrc',
  'quickbooks',
  'roshi',
  'sage-intacct',
  'salesforce',
  'stashstock',
  'xero',
  'zohobooks',
] as const;

export type IntegrationIconName = (typeof integrationIconNames)[number];
